// extracted by mini-css-extract-plugin
module.exports = {"root":"RelatedRequest_root__2GaqE","indicatorsContainer":"RelatedRequest_indicatorsContainer__1_yvD"};